import Image from 'next/image'
import type { CSSProperties } from 'react'
import type { StrapiImage as StrapiImageType } from 'types/strapi/image'

type StrapiImageProps = StrapiImageType & {
  className?: string
  priority?: boolean
  quality?: number
  style?: CSSProperties
}

export function StrapiImage({
  alternativeText,
  className = '',
  ext,
  formats,
  height,
  name,
  priority = false,
  provider,
  quality = 75,
  url,
  width,
  style = undefined,
}: StrapiImageProps) {
  if (!url) return null

  const shouldSrcset = formats !== null && ext !== '.svg'

  const sizes = shouldSrcset
    ? `(min-width: 320px) 640w,
    (min-width: 640px) 768w,
    (min-width: 768px) 1024w,
    (min-width: 1024px) 1280w,
    (min-width: 1280px) 1920w"`
    : undefined

  const finalUrl =
    provider === 'local'
      ? `${process.env.NEXT_PUBLIC_STRAPI_MEDIA_API_URL}${url}`
      : url

  return (
    <Image
      src={finalUrl}
      alt={alternativeText && alternativeText !== name ? alternativeText : ''}
      priority={priority}
      sizes={sizes}
      className={className}
      width={width}
      height={height}
      quality={quality}
      style={style}
    />
  )
}
